var React = require('react');

function RadioButton (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Checkout-Desktop--January","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","transform":"translate(-459 -2080)"},React.createElement("g",{"id":"Group-13","transform":"translate(430 2051)","fill":"#FFF","stroke":"#513265"},React.createElement("g",{"id":"Group-5","transform":"translate(30 28)"},React.createElement("circle",{"id":"Oval","cx":"14","cy":"16","r":"14"})))));
}

RadioButton.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = RadioButton;

RadioButton.default = RadioButton;
